import React from "react"
import PropTypes from "prop-types"
import ContactBlockItem from "./contact-block-item"

import * as styles from "./contact-block.module.css"
import classNames from "classnames"
import useShuffledContacts from "./use-shuffled-contacts"

const ContactBlock = ({ data }) => {
  const contacts = useShuffledContacts(data.multipleContacts)

  const wrapperClass = classNames(styles.wrapper, {
    [styles.comfortable]: contacts.length === 2,
    [styles.compact]: contacts.length > 2,
  })

  if (contacts?.length === 0) {
    return null
  }

  return (
    <div className={wrapperClass}>
      <section className="container">
        <div className="columns">
          <div className="column is-offset-2-desktop">
            <h2 dangerouslySetInnerHTML={{ __html: data.heading }} />
            <div className={styles.contacts}>
              {contacts.map((c, idx) => (
                <ContactBlockItem key={idx} contact={c} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

ContactBlock.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    contact: PropTypes.any,
    multipleContacts: PropTypes.array,
  }),
}

ContactBlock.defaultProps = {
  data: {
    heading: "",
    contact: {},
    multipleContacts: [],
  },
}

export default ContactBlock
